import { AUTH_TOKEN, AUTH_USER_PASSWORD } from '../../clients/constants';

const SECRET_HINT_ID = 'mcp.credentials.secretHint';

export const FIELDS = {
  instanceUrl: {
    labelId: 'mcp.credentials.instanceUrl.label',
    type: 'url',
    hintId: 'mcp.credentials.instanceUrl.hint'
  },
  apiToken: {
    labelId: 'mcp.credentials.apiToken.label',
    type: 'password',
    placeholderId: 'mcp.credentials.apiToken.placeholder',
    hintId: SECRET_HINT_ID
  },
  username: {
    labelId: 'mcp.credentials.username.label',
    type: 'text',
    placeholderId: 'mcp.credentials.fillsSnippets'
  },
  password: {
    labelId: 'mcp.credentials.password.label',
    type: 'password',
    placeholderId: 'mcp.credentials.fillsSnippets',
    hintId: SECRET_HINT_ID
  }
};

export const FIELDS_BY_AUTH_METHOD = {
  [AUTH_TOKEN]: ['instanceUrl', 'apiToken'],
  [AUTH_USER_PASSWORD]: ['instanceUrl', 'username', 'password']
};
